var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState, useEffect, useRef } from 'react';
import cs from 'classnames';
import Tree from '@arco-design/web-react/es/Tree';
import Button from '@arco-design/web-react/es/Button';
import { IconDown, IconClose } from '@arco-design/web-react/icon';
import Dropdown from '@arco-design/web-react/es/Dropdown';
import IconArrow from '../../icon/react-icon/IconArrow';
import elementInContainer from '../utils/element-in-container';
import { Tooltip } from '../index';
var BtnName = 'filter-title-btn';
function getFlatTreeData(nodes) {
    return nodes.reduce(function (list, item) {
        if (item.children && item.children.length) {
            return list.concat.apply(list, __spreadArrays([item], getFlatTreeData(item.children)));
        }
        return list.concat(item);
    }, []);
}
export default function MultipleFilter(props) {
    var disabled = props.disabled, onSelect = props.onSelect, dataSource = props.dataSource, _a = props.title, title = _a === void 0 ? 'Content' : _a, iconDownClassName = props.iconDownClassName, _b = props.iconDownStyle, iconDownStyle = _b === void 0 ? {} : _b, _c = props.checkedValues, checkedValues = _c === void 0 ? [] : _c, _d = props.defaultPopupVisible, defaultPopupVisible = _d === void 0 ? false : _d, _e = props.selectedContentPlaceholder, selectedContentPlaceholder = _e === void 0 ? 'Selected Content' : _e;
    var flatTreeData = getFlatTreeData(dataSource);
    var TitleNode = function (props) {
        var title = props.title;
        var ref = useRef(null);
        var _a = useState(false), tooltipVisible = _a[0], setTooltipVisible = _a[1];
        useEffect(function () {
            var current = ref.current;
            if (current) {
                var parentEle = current.parentElement;
                if (current.offsetWidth > parentEle.offsetWidth) {
                    setTooltipVisible(true);
                }
                else {
                    setTooltipVisible(false);
                }
            }
        }, []);
        var textNode = (React.createElement("span", { className: "tree-node-title" },
            React.createElement("span", { ref: ref }, title)));
        if (tooltipVisible) {
            return (React.createElement(Tooltip, { content: title }, textNode));
        }
        return textNode;
    };
    var MemoTitleNode = React.memo(TitleNode);
    var generatorTreeNodes = function (treeData, layer) {
        if (layer === void 0) { layer = 0; }
        layer++;
        return treeData.map(function (item) {
            var children = item.children, key = item.key, title = item.title, style = item.style, className = item.className, rest = __rest(item, ["children", "key", "title", "style", "className"]);
            return (React.createElement(Tree.Node, __assign({ key: key }, rest, { className: cs(['tree-node-item', className]), title: React.createElement(MemoTitleNode, { title: title }), style: __assign(__assign({}, (style || {})), { paddingLeft: layer * 23 - 22, width: 334 - layer * 23 }) }), children ? generatorTreeNodes(children, layer) : null));
        });
    };
    function wrapperSetExpandedKeys(data) {
        var newData = Array.from(new Set(data));
        setExpandedKeys(newData);
    }
    function wrapperSetCheckedKeys(data, spread) {
        if (spread === void 0) { spread = true; }
        var newData = Array.from(new Set(data));
        setCheckedKeys(newData);
        spread && onSelect && onSelect(newData);
    }
    function arrowClickHandle(node) {
        var key = node._key;
        if (!key) {
            return;
        }
        var hasValue = expandedKeys.includes(key);
        if (!hasValue) {
            wrapperSetExpandedKeys(__spreadArrays(expandedKeys, [key]));
        }
        else {
            var newKeys = expandedKeys.filter(function (item) { return item !== key; });
            wrapperSetExpandedKeys(newKeys);
        }
    }
    function findCanExpendChildrenKeys(key, result) {
        if (result === void 0) { result = []; }
        var target = flatTreeData.find(function (item) { return item.key === key; });
        result.push(key);
        if (target && target.children && target.children.length) {
            target.children.forEach(function (item) {
                if (item.key) {
                    findCanExpendChildrenKeys(item.key, result);
                }
            });
        }
        return result;
    }
    function findNoChildrenKeys(key, result) {
        if (result === void 0) { result = []; }
        var target = flatTreeData.find(function (item) { return item.key === key; });
        if (target && target.children && target.children.length) {
            target.children.forEach(function (item) { return findNoChildrenKeys(item.key || '', result); });
        }
        else {
            result.push(key);
        }
        return result;
    }
    function cancelCheckItem(key) {
        var newKeys = checkedKeys.filter(function (item) { return item !== key; });
        wrapperSetCheckedKeys(newKeys);
    }
    var btnRef = useRef(null);
    var _f = useState(false), showClear = _f[0], setShowClear = _f[1];
    var _g = useState(checkedValues), checkedKeys = _g[0], setCheckedKeys = _g[1];
    var _h = useState(checkedValues), expandedKeys = _h[0], setExpandedKeys = _h[1];
    var _j = useState(defaultPopupVisible), popupVisible = _j[0], setPopupVisible = _j[1];
    useEffect(function () {
        wrapperSetCheckedKeys(checkedValues, false);
    }, [checkedValues]);
    function clickPopupHandle(e) {
        var target = e.target;
        if (popupVisible
            && (!elementInContainer(target, BtnName, btnRef.current)
                && !elementInContainer(target, 'arco-trigger')
                && !elementInContainer(target, 'tree-node-title')
                && !elementInContainer(target, 'selected-content-item'))
            || elementInContainer(target, 'close-popup')) {
            setPopupVisible(false);
        }
    }
    useEffect(function () {
        window.addEventListener('click', clickPopupHandle);
        return function () { return window.removeEventListener('click', clickPopupHandle); };
    }, [popupVisible]);
    var checkedKeysCount = checkedKeys.length;
    var showIconClose = checkedKeysCount && showClear;
    var showIconDown = !checkedKeysCount || (checkedKeysCount && !showClear);
    var selectedContent = (React.createElement("div", { className: "selected-content-container-box" },
        React.createElement("div", { className: "selected-content-container" },
            !checkedKeysCount && React.createElement("span", { className: "container-placeholder" }, selectedContentPlaceholder),
            checkedKeys.map(function (key, index) {
                var _a;
                var title = (_a = flatTreeData.find(function (item) { return item.key === key; })) === null || _a === void 0 ? void 0 : _a.title;
                return (React.createElement("div", { key: index, className: "selected-content-item" },
                    React.createElement("span", { className: "selected-content-title" }, title),
                    React.createElement(IconClose, { className: "selected-content-close-icon", onClick: function () { return cancelCheckItem(key); } })));
            })),
        React.createElement("div", { className: "selected-content-all-close", onClick: function () { return wrapperSetCheckedKeys([]); } },
            React.createElement(IconClose, { className: "selected-content-all-close-icon" }))));
    var dropList = (React.createElement("div", { className: "tree-contianer" },
        selectedContent,
        React.createElement(Tree, __assign({ checkable: true, className: "tree-content", checkedKeys: checkedKeys, expandedKeys: expandedKeys, checkedStrategy: Tree.SHOW_CHILD, renderExtra: function (node) {
                var childrenData = node.childrenData;
                var hasChildren = childrenData && childrenData.length;
                return (hasChildren ? React.createElement(IconArrow, { className: cs([
                        node.expanded ? 'expanded-item' : ' ',
                        'tree-node-item-arrow',
                    ]), onClick: function () { return arrowClickHandle(node); } }) : null);
            }, onCheck: function (newCheckedKeys, extra) {
                var key = extra.node.key;
                if (extra.checked) {
                    wrapperSetExpandedKeys(__spreadArrays(expandedKeys, findCanExpendChildrenKeys(key)));
                }
                wrapperSetCheckedKeys(newCheckedKeys);
            } }, props, { onSelect: function (_, extra) {
                var key = extra.node.key;
                var target = flatTreeData.find(function (item) { return item.key === key; });
                if (!target) {
                    return;
                }
                var children = target.children;
                var childrenCheckedKeys = [key], isChecked = false;
                if (children && children.length) {
                    childrenCheckedKeys = findNoChildrenKeys(key);
                    isChecked = childrenCheckedKeys.every(function (k) { return checkedKeys.includes(k); });
                }
                else {
                    isChecked = checkedKeys.includes(key);
                }
                var newCheckedKeys = isChecked
                    ? checkedKeys.filter(function (k) { return !childrenCheckedKeys.includes(k); })
                    : __spreadArrays(checkedKeys, childrenCheckedKeys);
                wrapperSetExpandedKeys(__spreadArrays(expandedKeys, findCanExpendChildrenKeys(key)));
                wrapperSetCheckedKeys(newCheckedKeys);
            } }), generatorTreeNodes(dataSource))));
    return (React.createElement(Dropdown, __assign({}, props, { position: "bl", trigger: "click", droplist: dropList, popupVisible: popupVisible }),
        React.createElement(Button, { type: "text", ref: btnRef, disabled: disabled, onMouseEnter: function () { return setShowClear(true); }, onMouseLeave: function () { return setShowClear(false); }, onClick: function () { return setPopupVisible(!popupVisible); }, className: [BtnName, checkedKeysCount ? 'has-value' : ''] },
            title,
            !!checkedKeysCount && " (" + checkedKeysCount + ")",
            !!showIconClose && React.createElement(IconClose, { onClick: function () { return wrapperSetCheckedKeys([]); } }),
            !!showIconDown && React.createElement(IconDown, { style: iconDownStyle, className: iconDownClassName }))));
}
//# sourceMappingURL=multiple-filter.js.map